export const QUARKWORKS_CASES = [
    {
        image: "https://newsoft-ns.com/media/quarkworks_case/quarkworks_hello.webp",
        imageAlt: "Hello & Newsoft",
        header: "Hello |  project of ex-Google Engineers",
        link: "/cases/quarkworks/hello",
        desc: "Developed social media app for customizing interests",
        text: [
            "Social media app where you can set your interests in the application, build your own communities and chat with people.",
        ],
    },
    {
        image: "https://newsoft-ns.com/media/quarkworks_case/quarkworks_craft.webp",
        imageAlt: "Craft & Newsoft",
        header: "Craft | B2B project ",
        link: "/cases/quarkworks/craft",
        desc: "Developed SaaS analytics platform for businesses",
        text: [
            "SaaS analytics platform for businesses where the user can quickly analyze all the data on earnings, expenses, and the site from his Excel sheet, and was promptly provided with a comprehensive analysis accompanied by graphs.",
        ],
    },
    {
        image: "https://newsoft-ns.com/media/pednet_case/PedNet.webp",
        imageAlt: "PedNet & Newsoft",
        header: "PedNet | project for improving  the Well-being of Colombian Residents",
        link: "/cases/quarkworks/pednet",
        desc: "Developed app to enhance well-being for Colombia's residents",
        text: [
            "Mobile application for Android and iOS that allows people to interact with local authorities in America and report problems related to road safety, pedestrians, and cyclists.",
        ],
    }
]
